import { UserRole } from '@va/types/website';
import Config from 'Config';
import flagsmith from 'flagsmith';
import { isWixApp } from '../dashboard';
import { LocalStorage } from '../storage';
import { getUrlWithoutTrailingSlash } from '../url';

function getLocalFeatureFlagOverride(key: string): boolean | undefined {
  const storedValue = LocalStorage.getItem(key);
  if (storedValue === 'true') return true;
  if (storedValue === 'false') return false;
  return undefined;
}

export const featureFlagOverrideStorageKeys = {
  trendIntelDebug: 'visa-trend-intel-debug',
};

export enum FlagsmithFeatureFlags {
  WebsiteErrors = 'websiteErrors',
  TranslationKeys = 'translationKeys',
  Develop = 'develop',
  AWLChatwootWidget = 'awlChatwootWidget',
  MetaDataAnalytics = 'dashboard_meta_data_analytics',
  ColumnResizing = 'dashboard_column_resizing',
  TrendIntel = 'dashboard_trend_intel',
  TrendIntelOverviewCard = 'dashboard_trend_intel_overview_card',
}

export function isEcomModuleEnabled(userRole: UserRole) {
  if (isWixApp()) return false;
  return userRole !== UserRole.DASHBOARD;
}

export function isGAImportEnabled() {
  return true;
}

export function isWebsiteErrorsEnabled() {
  return flagsmith.hasFeature(FlagsmithFeatureFlags.WebsiteErrors);
}

export function isDevelopFeatureEnabled() {
  return flagsmith.hasFeature(FlagsmithFeatureFlags.Develop);
}

export function isTranslationKeysAccessEnabled() {
  return flagsmith.hasFeature(FlagsmithFeatureFlags.TranslationKeys);
}

export function initializeFlagsmith(customApiUrl: string = Config.standaloneBaseUrl) {
  try {
    return flagsmith.init({
      environmentID: Config.flagSmithEnvironmentId,
      api: `${getUrlWithoutTrailingSlash(customApiUrl)}/flagsmith/api/v1/`,
      preventFetch: true,
      cacheFlags: true,
      onChange: (previousFlags, params, loadingState) => {},
      defaultFlags: {
        abes: { enabled: false },
        websiteErrors: { enabled: false },
        translationKeys: { enabled: false },
        outgoingTraffic: { enabled: false },
        develop: { enabled: false },
      },
    });
  } catch (e) {
    console.log('Flagsmith error:', e);
  }
}

export function isMetaDataAnalyticsEnabled() {
  return flagsmith.hasFeature(FlagsmithFeatureFlags.MetaDataAnalytics);
}

export function isTrendIntelEnabled() {
  return isTrendIntelDebugEnabled() || flagsmith.hasFeature(FlagsmithFeatureFlags.TrendIntel);
}

export function isTrendIntelDebugEnabled() {
  return getLocalFeatureFlagOverride(featureFlagOverrideStorageKeys.trendIntelDebug) ?? false;
}
